import React from 'react';
import {
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import { User, Users } from 'lucide-react';
import { useI18n } from '@/hooks/useI18n';

interface SignUpTypeSelectorProps {
  signUpType: 'individual' | 'group';
  onSignUpTypeChange: (_: React.MouseEvent<HTMLElement>, newType: 'individual' | 'group' | null) => void;
}

const SignUpTypeSelector: React.FC<SignUpTypeSelectorProps> = ({
  signUpType,
  onSignUpTypeChange
}) => {
  const { t } = useI18n();
  
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>📝 {t('signup.signUpType')}</Typography>
      <ToggleButtonGroup
        value={signUpType}
        exclusive
        onChange={onSignUpTypeChange}
        aria-label="signup type"
        fullWidth
      >
        <ToggleButton value="individual" aria-label="individual signup">
          <User style={{ width: 20, height: 20, marginRight: 8 }} />
          {t('signup.individual')}
        </ToggleButton>
        <ToggleButton value="group" aria-label="group signup">
          <Users style={{ width: 20, height: 20, marginRight: 8 }} />
          {t('signup.group')}
        </ToggleButton>
      </ToggleButtonGroup>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {t('signup.signUpTypeDescription')}
      </Typography>
    </Box>
  );
};

export default SignUpTypeSelector;
